<template>
    <div>


        <app-header></app-header>

        <transition name="fade">
            <router-view></router-view>

        </transition>

        <app-footer></app-footer>


    </div>
</template>

<script>
import AppFooter from "../components/Footer.vue";
import AppHeader from "../components/Header.vue";

export default {
  components: {
    AppHeader,
    AppFooter
  },
  data() {
    return {};
  },
  methods: {},
  created() {},
  destroyed() {}
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/Main.vue